<template>
  <div class="demo_wrap">
    <Carousel @to-zixun="toZixun" />
    <div class="flex-container-fa hidden-xs-only">
      <div class="item" v-for="(item, index) in faList" :key="index">
        <el-card :body-style="{ padding: '0px' }" >
          <img :src="item.img" class="image">
          <div class="bg-mask">
            {{item.imgText}}
            <el-button type="primary" class="fa_btn" round @click="toZixun()">方案咨询</el-button>
          </div>
          <div class="fa-text">
            <div class="fa-title">{{ item.title }}</div>
            <div class="fa-desc">{{ item.desc }}</div>
          </div>
        </el-card>
      </div>
    </div>
    <div class="center-area " >
      <div class="hx-title" id="ljqh">应用场景</div>
      <div class="tab-content" style="margin-bottom: 0">
      <el-radio-group v-model="tabRadio" class="hidden-xs-only">
        <el-radio-button label="1">企业私有云盘</el-radio-button>
        <el-radio-button label="2">企业备份一体机</el-radio-button>
        <el-radio-button label="3">数据集中管理</el-radio-button>
        <el-radio-button label="4">全闪存SAN存储</el-radio-button>
        <el-radio-button label="5">PB级解决方案</el-radio-button>
        <el-radio-button label="6">异地容灾备份</el-radio-button>
      </el-radio-group>
        <el-radio-group v-model="tabRadio" class="hidden-sm-and-up">
          <el-radio-button label="1">企业私有云盘</el-radio-button>
          <el-radio-button label="2">企业备份一体机</el-radio-button>
          <el-radio-button label="3">数据集中管理</el-radio-button>
        </el-radio-group>
        <el-radio-group v-model="tabRadio" class="hidden-sm-and-up">
          <el-radio-button label="4">全闪存SAN存储</el-radio-button>
          <el-radio-button label="5">PB级解决方案</el-radio-button>
          <el-radio-button label="6">异地容灾备份</el-radio-button>
        </el-radio-group>
      </div>
      <div class="row-div">
        <el-row>
          <el-col :span="24" class="hidden-sm-and-up" v-if="tabRadio==='1'"><div class="hx-img height1" style="text-align: center"><img src="../../assets/img/synology-new/qysyyp.jpg" /></div></el-col>
          <el-col :span="12" :xs="24" class="hx-text height1" v-if="tabRadio==='1'">
            <div class="title-sub1">搭建企业网盘或文件服务器</div>
            <div class="title-sub2">群晖 NAS 满足文件共享、存储和容灾保护需求，节省部署预算。</div>
            <div class="hx-content hx-content-height1">
              <div class="line"></div>
              <div class="title-sy">文件管理</div>
              <div class="desc">Synology NAS 整合数据存储、存取和共享等一体化文件管理应用，通过 DSM 直观易用的管理界面，无论家庭用户，或是工作繁重的 IT 管理人员，都能轻松完成所有文件同步、安全设置，全权掌控数据。</div>
            </div>
            <div class="hx-content">
              <div class="line"></div>
              <div class="title-sy">异地文件同步与共享</div>
              <div class="desc">文件异地同步及共享时间长、速度慢？企业多台电脑间同步协作效率慢,安全隐患高？群晖跨电脑、跨地域同步及共享方案打通数据孤岛,实现自动同步和即时共享,建立企业文件中心。同时支持多版本备份,避免因误删、勒索病毒等导致文件丢失。</div>
            </div>
            <div class="hx-content">
              <div class="line"></div>
              <div class="title-sy">随时随地存取数据</div>
              <div class="desc">无论您身处何处，都可以通过网页端、客户端、手机 App 轻松访问 Synology NAS 中的数据。</div>
            </div>
            <div class="hx-content">
              <div class="line"></div>
              <div class="title-sy">团队协作 提升效率</div>
              <div class="desc">团队协作没有及时有效的工具，反而会增加问题解决时间和数据的累加，群晖提供强大的协作方案，简化业务或项目文件编辑、
                沟通以及时间管理。</div>
            </div>
            <el-button type="primary" round class="hx-btn" @click="toZixun">了解Synology 企业私有云盘</el-button>
          </el-col>
          <el-col :span="12" class="hidden-xs-only" v-if="tabRadio==='1'"><div class="hx-img height1" style="text-align: right"><img src="../../assets/img/synology-new/qysyyp.jpg" /></div></el-col>
          <el-col :span="12" :xs="24"  v-if="tabRadio==='2'"><div class="hx-img height2"><img src="../../assets/img/synology-new/bfytj.png" /></div></el-col>
          <el-col :span="12" :xs="24" v-if="tabRadio==='2'"><div class="hx-text height2">
            <div class="title-sub1">备份一体机保护您的数字资产</div>
            <div class="title-sub2">使用群晖备份一体机，备份物理服务器、虚拟机，以及 SaaS 服务，保护企业数据安全。 </div>
            <div class="hx-content">
              <div class="line"></div>
              <div class="title-sy">Windows 和 Linux</div>
              <div class="desc">整机备份 备份文件、应用程序和系统设置，为您的工作站提供保护。</div>
              <div class="desc">灵活还原 您可选择整机还原，或文件级还原，并即时还原虚拟机。</div>
            </div>
            <div class="hx-content hx-content-height1">
              <div class="line"></div>
              <div class="title-sy">VMware 和 Hyper-V</div>
              <div class="desc">无代理备份 连接到 VMware vSphere 或 Microsoft Hyper-V，无需安装代理程序，即可创建备份任务。</div>
              <div class="desc">快速还原 通过将虚拟机还原到原始位置或另一个 hypervisor(如 VirtualMachine Manager)，大幅缩短 RTO(恢复时间目标)时间。</div>
            </div>
            <div class="hx-content hx-content-height1">
              <div class="line"></div>
              <div class="title-sy">文件服务器</div>
              <div class="desc">无代理备份 通过 SMB 或 rsync 协议连接至文件服务器，无需安装代理程序，即可创建备份任务。</div>
              <div class="desc">灵活的文件保护功能 通过增量备份、镜像和多版本的备份模式，为企业提供灵活的备份方案。</div>
            </div>
            <div class="hx-content hx-content-height1">
              <div class="line"></div>
              <div class="title-sy">Microsoft 365 和 Google Workspace</div>
              <div class="desc">简化管理 连续备份 Microsoft 365 和 Google Workspace 帐户，且能自动侦测和保护同一个域中的新 Microsoft 365 帐户。</div>
              <div class="desc">强大的还原功能 还原邮箱、邮箱文件夹、邮件或附件与文件夹，同时保留原有的存取权限。</div>
              <div class="desc">智能搜索 通过简单的关键字搜索，获取邮件、日历、附件和联系人等信息。</div>
            </div>
            <el-button type="primary" round class="hx-btn" @click="toZixun">了解Synology 备份一体机</el-button>
          </div>
          </el-col>
          <el-col :span="24" class="hidden-sm-and-up" v-if="tabRadio==='3'"><div class="hx-img height3"><img src="../../assets/img/synology-new/sjjzgl.jpg" /></div></el-col>
          <el-col :span="12" :xs="24" v-if="tabRadio==='3'">
            <div class="hx-text height3">
              <div class="title-sub1">部署高效安全的边缘存储方案</div>
              <div class="title-sub2">部署 Synology 群晖提供的高性能、安全且多功能的边缘存储解决方案，可满足不断增长的数据管理需求。</div>
              <div class="hx-content">
                <div class="line"></div>
                <div class="title-sy">数据存储和处理速度</div>
                <div class="desc">Synology NAS/SAN 解决方案涵盖一系列性能各异的企业级存储服务器，从全闪存储和PB 级服务器到高性能网络供您选择。</div>
              </div>
              <div class="hx-content">
                <div class="line"></div>
                <div class="title-sy">专为远程管理而设计</div>
                <div class="desc">Synology DiskStation Manager (DSM) 专为远程管理而设计。Synology Central Management System (CMS) 和 Active Insight 让您能轻松监控并管理多台异地 Synology NAS，一旦问题发生时能即时解決延长服务正常运行时间。</div>
              </div>
              <div class="hx-content">
                <div class="line"></div>
                <div class="title-sy">数据冗余和灾难恢复</div>
                <div class="desc">硬件故障、人为误操作等都有可能造成 IT 服务停摆，对缺乏 IT 人员的企业来说，管理异地站点的数据时，小至更换硬盘，大至保证服务可用性，都能给企业带来巨大挑战。群晖提供直观易管理的操作界面，并且支持自动化流程简化 IT 管理成本。</div>
              </div>
              <el-button type="primary" round class="hx-btn"  id="gnys" @click="toZixun">了解Synology 数据集中管理</el-button>
            </div>
          </el-col>
          <el-col :span="12" class="hidden-xs-only" v-if="tabRadio==='3'"><div class="hx-img height3" style="text-align: right"><img src="../../assets/img/synology-new/sjjzgl.jpg" /></div></el-col>
          <el-col :span="12" :xs="24"  v-if="tabRadio==='4'"><div class="hx-img height3"><img src="../../assets/img/synology-new/qscsancc.jpg" /></div></el-col>
          <el-col :span="12" :xs="24" v-if="tabRadio==='4'"><div class="hx-text height3">
            <div class="title-sub1">构建高效安全的虚拟化存储</div>
            <div class="title-sub2">Synology 全闪存系统是数据库、虚拟机存储、在线事务处理 (OLTP) 以及其他 IO 密集型和延迟敏感型部署的理想选择。 </div>
            <div class="hx-content">
              <div class="line"></div>
              <div class="title-sy">冗余解决方案</div>
              <div class="desc">具有双控制器架构的双活系统可确保在发生设备故障时通过即时故障转移实现无缝运行。或者，可通过将 Synology 服务器进行配对来创建高可用性集群，以尽可能延长服务正常运行时间。</div>
            </div>
            <div class="hx-content hx-content-height1">
              <div class="line"></div>
              <div class="title-sy">快速数据恢复</div>
              <div class="desc">通过快照实现近乎即时的数据保护。数据的时间点副本可以在异地进行复制。在发生不可预见的中断时，可以快速还原服务，从而确保数据完整性并尽可能减少停机时间。</div>
            </div>
            <div class="hx-content hx-content-height1">
              <div class="line"></div>
              <div class="title-sy">安全可靠的块类存储</div>
              <div class="desc">支持单写多读 (WORM) 的不可变快照可安全存储数据的不可变副本，从而提供针对勒索软件攻击的较高保护级别并增强数据安全性。</div>
              <div class="desc">存储空间加密可保护敏感信息免遭未经授权的访问，即使物理设备丢失或被盗也是如此。</div>
            </div>
            <el-button type="primary" round class="hx-btn" @click="toZixun">了解Synology 全闪存SAN存储</el-button>
          </div>
          </el-col>
          <el-col :span="24" class="hidden-sm-and-up" v-if="tabRadio==='5'"><div class="hx-img height5" style="text-align: right"><img src="../../assets/img/synology-new/pbjjjfa.png" /></div></el-col>
          <el-col :span="12" :xs="24" v-if="tabRadio==='5'">
            <div class="hx-text height5">
              <div class="title-sub1">PB 级大容量存储解决方案</div>
              <div class="title-sub2">利用专为实现高可扩展性和性能而构建的服务器整合海量数据。</div>
              <div class="hx-content">
                <div class="line"></div>
                <div class="title-sy">适用于各种规模的组织的产品系列</div>
                <div class="desc">Synology 提供了广泛的选项来满足不同的规模和性能需求。入门级可扩展系统的起始容量为 240 TB，可扩充多达 9 倍，而较大的 60 槽式设备可扩充 5 倍到 6 PB。我们的解决方案适用于具有高存储需求的快速增长的公司和企业。</div>
              </div>
              <div class="hx-content">
                <div class="line"></div>
                <div class="title-sy">按需扩充，没有中断</div>
                <div class="desc">从长远来看，您可以从简单的初始配置和简化的管理中获益。借助在线存储扩充，在扩充设备上无缝添加新存储空间或扩充现有 RAID，而不会导致主机上的服务中断。</div>
              </div>
              <div class="hx-content">
                <div class="line"></div>
                <div class="title-sy">高效的多站点监控和管理</div>
                <div class="desc">通过自动实时监控、保护和故障排除建议，在 Synology 系统间提前发现潜在问题并提高 IT 运营效率。</div>
              </div>
              <el-button type="primary" round class="hx-btn"  id="gnys" @click="toZixun">了解Synology PB级大存储</el-button>
            </div>
          </el-col>
          <el-col :span="12" class="hidden-xs-only" v-if="tabRadio==='5'"><div class="hx-img height5" style="text-align: right"><img src="../../assets/img/synology-new/pbjjjfa.png" /></div></el-col>

          <el-col :span="12" :xs="24" v-if="tabRadio==='6'"><div class="hx-img height5"><img src="../../assets/img/synology-new/ydzrbf1.png" /></div></el-col>
          <el-col :span="12" :xs="24" v-if="tabRadio==='6'"><div class="hx-text height5">
            <div class="title-sub1">将NAS备份到另一台 Synology NAS</div>
            <div class="title-sub2">数据备份可以在发生意外状况时提供安全保障，是企业规划 IT 架构不可或缺的一部分。 </div>
            <div class="hx-content">
              <div class="line"></div>
              <div class="title-sy">多样的备份目的地</div>
              <div class="desc">为 Synology NAS 的设置数据、应用程序和系统设置进行自动备份。并且通过压缩和重复数据删除可大幅减少所需的存储空间。</div>
            </div>
            <div class="hx-content hx-content-height1">
              <div class="line"></div>
              <div class="title-sy">多种备份方式支持</div>
              <div class="desc">支持整机备份 DSM 系统，当发生意外故障时，可以进行 NAS 整机还原以恢复到原先完好状态，也可以通过文件级还原，快速恢复特定文件。DSM 系统备份支持排程计划、增量备份、全局重删，节省备份所需的时间和存储空间。</div>
            </div>
            <div class="hx-content hx-content-height1">
              <div class="line"></div>
              <div class="title-sy">效率更高的数据保护</div>
              <div class="desc">对于经常使用和修改的文档来说，快照和复制任务可每 5 分钟执行一次。</div>
            </div>
            <el-button type="primary" round class="hx-btn" @click="toZixun">了解Synology 异地容灾备份 </el-button>
          </div>
          </el-col>
          <el-col :span="24" class="hidden-sm-and-up" v-if="tabRadio==='6'"><div class="hx-img height4"><img src="../../assets/img/synology-new/ydzrbf2.png" /></div></el-col>
          <el-col :span="12" :xs="24" v-if="tabRadio==='6'">
            <div class="hx-text height4">
              <div class="title-sub1">备份 Synology NAS 数据到公有云平台</div>
              <div class="title-sub2">数据备份可以在发生意外状况时提供安全保障，是企业规划 IT 架构不可或缺的一部分。</div>
              <div class="hx-content">
                <div class="line"></div>
                <div class="title-sy">多样的选择</div>
                <div class="desc">Hyper Backup 支持将 Synology NAS 数据备份到公有云平台。通过数据和索引完整性检查以检测以前的备份版本是否有数据损坏。</div>
              </div>
              <div class="hx-content">
                <div class="line"></div>
                <div class="title-sy">文件备份利器</div>
                <div class="desc">与公有云平台（例如百度网盘、腾讯云或阿里云）连接，设置单向或双向同步。</div>
              </div>
              <el-button type="primary" round class="hx-btn"  id="gnys" @click="toZixun">了解Synology 异地容灾备份</el-button>
            </div>
          </el-col>
          <el-col :span="12" class="hidden-xs-only" v-if="tabRadio==='6'"><div class="hx-img height4" style="text-align: right"><img src="../../assets/img/synology-new/ydzrbf2.png" /></div></el-col>
          <el-col :span="12" :xs="24" v-if="tabRadio==='6'"><div class="hx-img height4" style="text-align: right"><img src="../../assets/img/synology-new/ydzrbf3.png" /></div></el-col>
          <el-col :span="12" :xs="24" v-if="tabRadio==='6'">
            <div class="hx-text height4">
              <div class="title-sub1">备份数据到外部设备</div>
              <div class="title-sub2">将数据备份到移动硬盘等其他外部存储设备</div>
              <div class="hx-content">
                <div class="line"></div>
                <div class="title-sy">文件和系统设定</div>
                <div class="desc">Hyper Backup 支持多种备份策略和目的地，并通过版本管理、压缩和重复数据删除来提高存储空间使用率。并且包括 Synology NAS 的应用程序和系统设置也可以进行备份。</div>
              </div>
              <div class="hx-content">
                <div class="line"></div>
                <div class="title-sy">文件备份利器</div>
                <div class="desc">USB Copy 支持在接入移动硬盘时，自动触发数据导出任务。</div>
              </div>
              <el-button type="primary" round class="hx-btn"  id="gnys" @click="toZixun">了解Synology 异地容灾备份</el-button>
            </div>
          </el-col>
        </el-row>
      </div>

    </div>
    <div class="shouquan">
      <div class="center-area">
        <div class="img-area hidden-xs-only">
          <div class="img-item" v-for="(item, index) in ryList" :key="index">
            <img :src="item.img" />
            <div class="number">{{ item.title }}</div>
            <el-divider class="line"/>
            <div class="desc">{{ item.desc }}</div>
          </div>
        </div>
        <div class="img-area hidden-sm-and-up">
          <el-row>
          <el-col :span="12" class="img-item" v-for="(item, index) in ryList" :key="index">
            <img :src="item.img" />
            <div class="number">{{ item.title }}</div>
            <el-divider class="line"/>
            <div class="desc">{{ item.desc }}</div>
          </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <div class="center-area" style="background-color: #fff">
      <div class="hx-title">产品中心</div>
      <div class="hx-desc hidden-xs-only">群晖 Synology 至今已销售1300多万台产品，遍及全球各种产业，其中更不乏数千名使用者同时在线的关键服务，维系着许多企业的经营命脉。我们</div>
      <div class="hx-desc hidden-xs-only">谨慎看待自己对客户的使命，严格要求产品在不同应用环境下皆能稳定且高效地运行，为客户妥善管理、保护每一份数据</div>
      <div class="tab-content hidden-xs-only">
<!--        <div style="width: 40%;float: left">-->
        <div class="half-inner"  @click="setFirstLevel('1')">
        <el-radio-group v-model="firstLevel"  @change="changeFirstLevel">
          <el-radio-button label="1">塔式服务器 </el-radio-button>
        </el-radio-group>
        </div>
        <div class="half-inner-middle" style="width: 25%">
          <el-radio-group v-model="secondLevel" @change="changeSecondLevel">
            <el-radio-button label="1">入门存储需求</el-radio-button>
            <el-radio-button label="2">进阶数据管理</el-radio-button>
          </el-radio-group>
        </div>
<!--        </div>-->
<!--        <div style="width: 60%;float: left">-->
        <div class="half-inner" style="width: 12.5%;">&nbsp;&nbsp;&nbsp;&nbsp;</div>

        <div class="half-inner-right" style="width: 37.5%;float: right;text-align: center">

          <el-radio-group v-model="secondLevel" @change="changeSecondLevel">
            <el-radio-button label="3">全闪存阵列</el-radio-button>
            <el-radio-button label="4">高扩充性</el-radio-button>
            <el-radio-button label="5">通用存储</el-radio-button>
          </el-radio-group>
        </div>
        <div class="half-inner" style="float: right;" @click="setFirstLevel('2')">
          <el-radio-group v-model="firstLevel"  @change="changeFirstLevel">
            <el-radio-button label="2">机架式服务器</el-radio-button>
          </el-radio-group>
        </div>
<!--        </div>-->
      </div>
      <div class="tab-content hidden-sm-and-up">
        <!--        <div style="width: 40%;float: left">-->
        <div style="width: 100%"  @click="setFirstLevel('1')">
        <div class="half-inner" style="width: 30%">
          <el-radio-group v-model="firstLevel" @change="changeFirstLevel">
            <el-radio-button label="1">塔式服务器 </el-radio-button>
          </el-radio-group>
        </div>
        <div class="half-inner-middle" style="width: 50%">
          <el-radio-group v-model="secondLevel" @change="changeSecondLevel">
            <el-radio-button label="1">入门存储需求</el-radio-button>
            <el-radio-button label="2">进阶数据管理</el-radio-button>
          </el-radio-group>
        </div>
        <!--        </div>-->
        <!--        <div style="width: 60%;float: left">-->
<!--        <div class="half-inner" style="width: 25%;">&nbsp;&nbsp;&nbsp;&nbsp;</div>-->
        </div>
        <div style="width: 100%">
        <div class="half-inner-right" style="width: 70%;float: right;text-align: center">

          <el-radio-group v-model="secondLevel" @change="changeSecondLevel">
            <el-radio-button label="3">全闪存阵列</el-radio-button>
            <el-radio-button label="4">高扩充性</el-radio-button>
            <el-radio-button label="5">通用存储</el-radio-button>
          </el-radio-group>
        </div>
        <div class="half-inner" style="float: right;width: 30%"  @click="setFirstLevel('2')" >
          <el-radio-group v-model="firstLevel" @change="changeFirstLevel">
            <el-radio-button label="2">机架式服务器</el-radio-button>
          </el-radio-group>
        </div>
        </div>
        <!--        </div>-->
      </div>
      <div class="flex-container-product" v-if="secondLevel==='1'|| (secondLevel===''&&firstLevel==='1')">
        <div class="item" v-for="(item, index) in TSRMProductList" :key="index">
          <el-card :body-style="{ padding: '0px' }" shadow="never">
            <img :src="item.img" class="image">
            <div class="bg-mask">
              <el-button type="primary" class="fa_btn" round @click="toZixun()">获取报价</el-button>
            </div>
            <div class="pro-text">
              <div class="pro-title">
                {{ item.title }}
                <el-tag :type="item.flag==='1'?'':'danger'" effect="dark" v-if="item.flag!=='0'">{{ item.flag==='1'?'新品':'热销' }}</el-tag>
                <span class="pro-yp" style="float: right">{{ item.yp }}</span></div>
              <el-divider class="line"/>
              <div class="pro-desc"><div class="point"></div>{{ item.desc1 }}</div>
              <div class="pro-desc"><div class="point"></div>{{ item.desc2 }}</div>
              <div class="pro-desc"><div class="point"></div>{{ item.desc3 }}</div>
            </div>
          </el-card>
        </div>
      </div>
      <div class="flex-container-product" v-if="secondLevel==='2'|| (secondLevel===''&&firstLevel==='1')">
        <div class="item" v-for="(item, index) in TSJJProductList" :key="index">
          <el-card :body-style="{ padding: '0px' }" shadow="never">
            <img :src="item.img" class="image">
            <div class="bg-mask">
              <el-button type="primary" class="fa_btn" round @click="toZixun()">获取报价</el-button>
            </div>
            <div class="pro-text">
              <div class="pro-title">
                {{ item.title }}
                <el-tag :type="item.flag==='1'?'':'danger'" effect="dark" v-if="item.flag!=='0'">{{ item.flag==='1'?'新品':'热销' }}</el-tag>
                <span class="pro-yp" style="float: right">{{ item.yp }}</span>
              </div>
              <el-divider class="line"/>
              <div class="pro-desc"><div class="point"></div>{{ item.desc1 }}</div>
              <div class="pro-desc"><div class="point"></div>{{ item.desc2 }}</div>
              <div class="pro-desc"><div class="point"></div>{{ item.desc3 }}</div>
            </div>
          </el-card>
        </div>
      </div>

      <div class="flex-container-product" v-if="secondLevel==='3'|| (secondLevel===''&&firstLevel==='2')">
        <div class="item" v-for="(item, index) in JJQSCProductList" :key="index">
          <el-card :body-style="{ padding: '0px' }" shadow="never">
            <img :src="item.img" class="image">
            <div class="bg-mask">
              <el-button type="primary" class="fa_btn" round @click="toZixun()">获取报价</el-button>
            </div>
            <div class="pro-text">
              <div class="pro-title">
                {{ item.title }}
                <el-tag :type="item.flag==='1'?'':'danger'" effect="dark" v-if="item.flag!=='0'">{{ item.flag==='1'?'新品':'热销' }}</el-tag>
                <span class="pro-yp" style="float: right">{{ item.yp }}</span></div>
              <el-divider class="line"/>
              <div class="pro-desc"><div class="point"></div>{{ item.desc1 }}</div>
              <div class="pro-desc"><div class="point"></div>{{ item.desc2 }}</div>
              <div class="pro-desc"><div class="point"></div>{{ item.desc3 }}</div>
            </div>
          </el-card>
        </div>
      </div>
      <div class="flex-container-product" v-if="secondLevel==='4'">
        <div class="item" v-for="(item, index) in JJGKCProductList" :key="index">
          <el-card :body-style="{ padding: '0px' }" shadow="never">
            <img :src="item.img" class="image">
            <div class="bg-mask">
              <el-button type="primary" class="fa_btn" round @click="toZixun()">获取报价</el-button>
            </div>
            <div class="pro-text">
              <div class="pro-title">
                {{ item.title }}
                <el-tag :type="item.flag==='1'?'':'danger'" effect="dark" v-if="item.flag!=='0'">{{ item.flag==='1'?'新品':'热销' }}</el-tag>
                <span class="pro-yp" style="float: right">{{ item.yp }}</span></div>
              <el-divider class="line"/>
              <div class="pro-desc"><div class="point"></div>{{ item.desc1 }}</div>
              <div class="pro-desc"><div class="point"></div>{{ item.desc2 }}</div>
              <div class="pro-desc"><div class="point"></div>{{ item.desc3 }}</div>
            </div>
          </el-card>
        </div>
      </div>
      <div class="flex-container-product" v-if="secondLevel==='5'">
        <div class="item" v-for="(item, index) in JJTYCCProductList" :key="index">
          <el-card :body-style="{ padding: '0px' }" shadow="never">
            <img :src="item.img" class="image">
            <div class="bg-mask">
              <el-button type="primary" class="fa_btn" round @click="toZixun()">获取报价</el-button>
            </div>
            <div class="pro-text">
              <div class="pro-title">
                {{ item.title }}
                <el-tag :type="item.flag==='1'?'':'danger'" effect="dark" v-if="item.flag!=='0'">{{ item.flag==='1'?'新品':'热销' }}</el-tag>
                <span class="pro-yp" style="float: right">{{ item.yp }}</span></div>
              <el-divider class="line"/>
              <div class="pro-desc"><div class="point"></div>{{ item.desc1 }}</div>
              <div class="pro-desc"><div class="point"></div>{{ item.desc2 }}</div>
              <div class="pro-desc"><div class="point"></div>{{ item.desc3 }}</div>
            </div>
          </el-card>
        </div>
      </div>
      <div class="flex-container-product" v-if="secondLevel===''&&firstLevel==='2'">
        <div class="item" v-for="(item, index) in JJGKCProductList" :key="index">
          <el-card :body-style="{ padding: '0px' }" shadow="never">
            <img :src="item.img" class="image">
            <div class="bg-mask">
              <el-button type="primary" class="fa_btn" round @click="toZixun()">获取报价</el-button>
            </div>
            <div class="pro-text">
              <div class="pro-title">
                {{ item.title }}
                <el-tag :type="item.flag==='1'?'':'danger'" effect="dark" v-if="item.flag!=='0'">{{ item.flag==='1'?'新品':'热销' }}</el-tag>
                <span class="pro-yp" style="float: right">{{ item.yp }}</span></div>
              <el-divider class="line"/>
              <div class="pro-desc"><div class="point"></div>{{ item.desc1 }}</div>
              <div class="pro-desc"><div class="point"></div>{{ item.desc2 }}</div>
              <div class="pro-desc"><div class="point"></div>{{ item.desc3 }}</div>
            </div>
          </el-card>
        </div>
        <div class="item" v-for="(item, index) in JJTYCCProductList" :key="index">
          <el-card :body-style="{ padding: '0px' }" shadow="never">
            <img :src="item.img" class="image">
            <div class="bg-mask">
              <el-button type="primary" class="fa_btn" round @click="toZixun()">获取报价</el-button>
            </div>
            <div class="pro-text">
              <div class="pro-title">
                {{ item.title }}
                <el-tag :type="item.flag==='1'?'':'danger'" effect="dark" v-if="item.flag!=='0'">{{ item.flag==='1'?'新品':'热销' }}</el-tag>
                <span class="pro-yp" style="float: right">{{ item.yp }}</span></div>
              <el-divider class="line"/>
              <div class="pro-desc"><div class="point"></div>{{ item.desc1 }}</div>
              <div class="pro-desc"><div class="point"></div>{{ item.desc2 }}</div>
              <div class="pro-desc"><div class="point"></div>{{ item.desc3 }}</div>
            </div>
          </el-card>
        </div>
      </div>
      <div style="text-align: center"><el-button type="primary" round class="ys-btn" @click="toZixun">方案咨询</el-button></div>
    </div>

    <div class="khkf hidden-xs-only">
      <div class="khkf-center-area">
        <el-carousel arrow="never" >
          <el-carousel-item v-for="(item,index) in kfList" :key="index">
            <div class="title">{{ item.title }}</div>
            <div class="msg">{{ item.msg }}</div>
            <div class="person">{{ item.person }}</div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <div class="center-area">
      <div class="hx-title">功能优势</div>
      <div class="hx-desc hidden-xs-only">群晖凭借多层级用户管理、文件协同编辑、版本回溯和不可变文件夹等先进功能，提供强大的数据保护与高效协作能力，满足企业对安全性、灵活性和数据管理的高标准需求</div>
      <el-row :gutter="10" class="youshi-row">
        <el-col :span="8" :xs="12">
          <el-card class="box-card ys-card">
            <div><img src="../../assets/img/synology/ys-1.svg"/></div>
            <div class="ys-title">融入现有 IT 的平滑迁移</div>
            <div class="ys-desc">支持 Windows AD 域和 LDAP 目录服务，可直接加入企业已有帐号系统。并且支持 Windows ACL 13 种权限，实现平滑迁移，无需建立新帐号。</div>
          </el-card>
        </el-col>
        <el-col :span="8" :xs="12">
          <el-card class="box-card ys-card">
            <div><img src="../../assets/img/synology/ys-2.svg"/></div>
            <div class="ys-title">多层级用户管理</div>
            <div class="ys-desc">委派用户能管理用户帐户以及共享文件夹，从而减轻 IT 管理员因人事变动而产生的工作量。</div>
          </el-card>
        </el-col>
        <el-col :span="8" :xs="12">
          <el-card class="box-card ys-card">
            <div><img src="../../assets/img/synology/ys-3.svg"/></div>
            <div class="ys-title">文件协同编辑</div>
            <div class="ys-desc">使用 Synology Office 进行实时协作，多人同时在线编辑电子表格、文档和幻灯片。</div>
          </el-card>
        </el-col>
        <el-col :span="8" :xs="12">
          <el-card class="box-card ys-card">
            <div><img src="../../assets/img/synology/ys-4.svg"/></div>
            <div class="ys-title">文件版本回溯</div>
            <div class="ys-desc">备份文件可保留 32 个历史版本，避免重要文件丢失或者覆盖。</div>
          </el-card>
        </el-col>
        <el-col :span="8" :xs="12">
          <el-card class="box-card ys-card">
            <div><img src="../../assets/img/synology/ys-5.svg"/></div>
            <div class="ys-title">不可变文件夹</div>
            <div class="ys-desc">WriteOnce 技术可防止修改或删除敏感数据。这使得它非常适合归档和维护法规合规性。</div>
          </el-card>
        </el-col>
        <el-col :span="8" :xs="12">
          <el-card class="box-card ys-card">
            <div><img src="../../assets/img/synology/ys-6.png"/></div>
            <div class="ys-title">一机整备，无需授权</div>
            <div class="ys-desc">通过Active Backup for Business，您可以全权掌握物理和虚拟环境的备份任务，随时访问您的数据与服务。</div>
          </el-card>
        </el-col>
        <el-col :span="8" :xs="12">
          <el-card class="box-card ys-card">
            <div><img src="../../assets/img/synology/ys-7.png"/></div>
            <div class="ys-title">高可用集群（HA）</div>
            <div class="ys-desc">将2套群晖NAS组成高可用集群（HA），确保服务长期稳定运行，数据随时可用。</div>
          </el-card>
        </el-col>
        <el-col :span="8" :xs="12">
          <el-card class="box-card ys-card">
            <div><img src="../../assets/img/synology/ys-8.png"/></div>
            <div class="ys-title">支持多个备份目的地</div>
            <div class="ys-desc">通过Hyper Backup将群晖 Synology 系统备份到本地存储空间、外接设备、其他群晖、rsync 服务器或公有云服务。</div>
          </el-card>
        </el-col>
        <el-col :span="8" :xs="12">
          <el-card class="box-card ys-card">
            <div><img src="../../assets/img/synology/ys-9.png"/></div>
            <div class="ys-title">块级数据保护</div>
            <div class="ys-desc">Snapshot Replication 快照通过适用于多种备份策略的快照技术，可实现接近瞬时的数据恢复，确保业务连续性。</div>
          </el-card>
        </el-col>
        <el-col :span="24"><el-button type="primary" round class="ys-btn" @click="toZixun">方案咨询</el-button></el-col>
      </el-row>

    </div>


    <div class="sy-contact">
      <div class="sq-title">联系我们</div>
      <div class="sq-desc hidden-xs-only">立即启用 Synology 解决方案，为您的数据保驾护航！</div>
      <div class="sq-desc hidden-sm-and-up">立即启用 Synology 解决方案，</div>
      <div class="sq-desc hidden-sm-and-up">为您的数据保驾护航！</div>
      <el-button class="ljzx" @click="toZixun">立即咨询<i class="el-icon-arrow-right el-icon--right"></i></el-button>
    </div>
    <div class="center-area">
      <div class="hx-title">成功案例</div>
      <div class="hx-desc hidden-xs-only">当前有数百万台 Synology 服务器已开启并在运行，帮助各行各业应对市场挑战</div>
      <el-row :gutter="10" class="youshi-row">
        <el-col :span="8" :xs="24" v-for="(item, index) in caseList" :key="index" class="case-item">
          <el-card :body-style="{ padding: '0px' }">
            <div class="ys-img"><img :src="item.src" style="width: 100%"/></div>
            <div class="bg-mask hidden-xs-only">
              <el-button type="primary" class="fa_btn" round @click="toZixun()">方案咨询</el-button>
            </div>
            <div class="ys-area">
              <div class="ys-title" style="text-align: left">{{ item.title }}</div>
              <div class="ys-desc" style="text-align: left;color:#B3B3B3 ">{{ item.desc }}</div>
              <div class="ys-desc" style="text-align: left">{{item.msg}}</div>
            </div>
          </el-card>
        </el-col>
        <el-col :span="24"><el-button type="primary" round class="ys-btn" @click="toZixun">方案咨询</el-button></el-col>
      </el-row>
    </div>
    <div class="center-area hidden-xs-only">
      <div class="hx-title">寻找适合的解决方案<span style="color:#E5E5E5;">（服务支持）</span></div>
      <el-row :gutter="20" class="youshi-row">
        <el-col :span="8" :xs="12" class="case-item">
          <el-card :body-style="{ padding: '0px' }" class="support-item">
            <div><img src="../../assets/img/synology-new/fwzc-01.jpg" style="width: 100%"/></div>
              <div class="ys-title" style="text-align: left">产品问题咨询</div>
              <div class="ys-desc ys-height" style="text-align: left">请向我们的专家咨询，以获取在线演示，产品推荐和部署建议。</div>
              <div class="ys-desc ys-btn-area" style="text-align: left;color:#0052D9;cursor: pointer" @click="toZixun"><div class="arrow-text">产品咨询</div><img src="../../assets/img/synology-new/arrow.svg" class="arrow"/></div>
          </el-card>
        </el-col>
        <el-col :span="8" :xs="12" class="case-item">
          <el-card :body-style="{ padding: '0px' }" class="support-item">
            <div><img src="../../assets/img/synology-new/fwzc-02.jpg" style="width: 100%"/></div>
              <div class="ys-title" style="text-align: left">获取免费方案</div>
              <div class="ys-desc ys-height" style="text-align: left">您有采购计划吗？我们可以定制我们的服务以符合您的目标。</div>
              <div class="ys-desc ys-btn-area" style="text-align: left;color:#0052D9;cursor: pointer " @click="toZixun"><div class="arrow-text">方案咨询</div><img src="../../assets/img/synology-new/arrow.svg" class="arrow"/></div>
          </el-card>
        </el-col>
        <el-col :span="8" :xs="12" class="case-item">
          <el-card :body-style="{ padding: '0px' }" class="support-item">
            <div><img src="../../assets/img/synology-new/fwzc-03.jpg" style="width: 100%"/></div>
              <div class="ys-title" style="text-align: left">寻找适合的NAS</div>
              <div class="ys-desc ys-height" style="text-align: left">您可以使用NAS选择器找到理想的NAS，并通过Synology合作伙伴购买。</div>
              <div class="ys-desc ys-btn-area" style="text-align: left;color:#0052D9;cursor: pointer" @click="toZixun"><div class="arrow-text">型号推荐</div><img src="../../assets/img/synology-new/arrow.svg" class="arrow"/></div>
          </el-card>
        </el-col>
      </el-row>
    </div>

      <div class="center-area">
        <div class="hx-title">服务客户</div>
        <div class="flex-container">
          <div v-for="(item, index) in customerList" :key="index" class="item">
            <img :src="item.src" width="100%" v-if="index === customerList.length-1" class="hidden-xs-only"/>
            <img :src="item.src" width="100%" v-else/>
          </div>
        </div>
      </div>
    <div class="sy-footer">
      <div class="center-area">
        <el-row :gutter="20">
          <el-col :span="11" :xs="24">
            <img src="../../assets/img/synology-new/sy-ly-logo.svg" style="width: 50%"/>
            <div class="sy-desc">群晖 Synology 网络存储服务器 (NAS) —— 专为企业和个人用户打造的高性能数据存储与备份解决方案，提供安全、可靠、智能化的数据管理体验。</div>
            <div class="sy-desc">作为群晖 Synology 官方授权代理商，良悦科技凭借专业的产品销售与技术支持，持续优化服务品质，为各行业客户提供高效、可信赖的一站式采购及售后保障，助力企业数字化转型与个人数据安全管理。</div>
          </el-col>
          <el-col :span="8" :xs="24">&nbsp;</el-col>
          <el-col :span="5" :xs="24">
            <div class="sy-desc2" style="font-weight: bold">联系方式</div>
            <div class="sy-desc2"><span class="sub-name">售前咨询：</span>15838022117</div>
            <div class="sy-desc2"><span class="sub-name">综合咨询：</span>400-033-9003</div>
            <div class="sy-desc2"><span class="sub-name">联系邮箱：wuty@liangy.cn</span></div>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="copyright  hidden-xs-only">
      <span style=" color: #999696">Copyright ©河南良悦信息科技有限公司版权所有 &emsp;</span>
      <span>豫ICP备2022018655号-1</span>
    </div>
    <el-dialog
        title=""
        :visible.sync="centerDialogVisible"
        class="sy-dialog"
        center>
      <div class="dialog-title">新一代企业数据基础设施构建解决方案</div>
      <div class="dialog-desc">河南地区售前咨询电话15838022117</div>
      <div class="radio-style-sy hidden-xs-only">
        功能需求：
        <el-checkbox-group v-model="checkList">
          <el-checkbox label="私有云盘">私有云盘：企业云盘/安全文件共享/支持Windows、macOS、移动设备</el-checkbox>
          <el-checkbox label="备份与恢复">备份与恢复：集中备份VM、服务器 / 自动备份+异地容灾/勒索病毒快速恢复</el-checkbox>
          <el-checkbox label="存储服务器">存储服务器：团队协作/公有云数据实时同步/32版本回溯保障数据安全/数据异地同步</el-checkbox>
          <el-checkbox label="其他">其他：监控/虚拟化/边缘计算/办公效率/多媒体/文件传输与共享等</el-checkbox>
        </el-checkbox-group>
      </div>
      <div class="radio-style-sy hidden-sm-and-up">
        <div class="checkbox-title">功能需求:</div>
        <el-checkbox-group v-model="checkList">
          <el-row>
            <el-col :span="12">
              <el-checkbox label="私有云盘">私有云盘</el-checkbox>
            </el-col>
            <el-col :span="12">
              <el-checkbox label="备份与恢复">备份与恢复</el-checkbox>
            </el-col>
            <el-col :span="12">
              <el-checkbox label="存储服务器">存储服务器</el-checkbox>
            </el-col>
            <el-col :span="12">
              <el-checkbox label="其他">其他</el-checkbox></el-col>
          </el-row>


        </el-checkbox-group>
      </div>
      <el-row :gutter="20">
        <el-col :span="12" :xs="24">
          <el-input placeholder="姓名" v-model="name" class="input-style">
            <template slot="prepend"><img src="../../assets/img/synology/sy-name.svg"/>
              <!--          <el-divider direction="vertical" class="in-line"></el-divider>-->
            </template>
          </el-input>
        </el-col>
        <el-col :span="12" :xs="24">
          <el-input placeholder="联系手机" v-model="phone" class="input-style">
            <template slot="prepend"><img src="../../assets/img/synology/sy-phone.svg"/>
              <!--          <el-divider direction="vertical" class="in-line"></el-divider>-->
            </template>
          </el-input>
        </el-col>
        <el-col :span="24">
          <el-input placeholder="需求内容" v-model="remark" class="input-style">
            <template slot="prepend"><img src="../../assets/img/synology/sy-remark.svg"/>
            </template>
          </el-input>
        </el-col>
      </el-row>





      <span slot="footer" class="dialog-footer">
        <el-button @click="reset()"  >&nbsp;&nbsp;&nbsp;&nbsp;重置&nbsp;&nbsp;&nbsp;&nbsp;</el-button>
        <el-button type="primary" @click="toSubmit()" style="background-color: #0052D9">提交需求</el-button>

      </span>
    </el-dialog>
    <el-dialog
      title="请输入验证码"
      :visible.sync="captchaDialogVisible"
      width="300px"
      :modal="true"
      :close-on-click-modal="false"
      center>
      <img class="captcha-img" :src="captchaBase64Image" @click="getCaptcha" />
      <el-input class="captcha-input" v-model="captchaCode" placeholder="请输入验证码" />

    <span slot="footer" class="dialog-footer">
      <el-button @click="captchaDialogVisible = false" class="dialog-btn">取 消</el-button>
    <el-button type="primary" @click="onSubmit()" style="background-color: #0052D9"  class="dialog-btn">确 定</el-button>

  </span>
  </el-dialog>


  </div>
</template>

<script>
import Carousel from '@/components/synology/carousel.vue'
export default {
  components: {
    Carousel
  },
  data() {
    return {
      checkList:[],
      tabRadio: '1',
      firstLevel: '1',
      secondLevel: '',
      centerDialogVisible: false,
      captchaDialogVisible: false,
      name: '',
      phone: '',
      company: '',
      remark: '',
      type: '',
      captchaCode: '',
      captchaUuid: '',
      captchaBase64Image: '',
      refreshCaptchaInterval: null,
      kfList: [
        {
          title: '华东理工大学信息学院',
          msg:'“通过将群晖作为我们的存储节点，增加了计算资源分配使用的弹性，同学们在不同服务器上运行计算任务，都只需从群晖的存储空间上调取数据即可，避免以往需要排队实验、拷贝实验数据的情况，并且也降低了数据重复率。更重要的是，群晖直观的操作方式，也降低了维护难度，更不用每次维护都需要备份一次实验数据，大幅提升了我们的实验效率。”',
          person:'——华东理工大学信息学院 在读博士 曾健骏'
        },
        {
          title: '河北医科大学第一医院',
          msg:'“群晖 NAS 为我们提供的集中存储解决方案，配合无需授权许可的备份服务，能够满足我们小时级定时备份 PACS 影像数据的需求，实现海量热数据安全保障。群晖 NAS 可扩充性强，扩容存储空间快速高效，足以应对我们潜在的数据增长挑战。总而言之，群晖存储以经济、高效和便利的方式解决了 PACS 海量数据的备份问题，为医院的医疗数据上了一道合规级别的安全锁。”',
          person:'————河北医科大学第一医院 智慧医院建设部 张工'
        },
        {
          title: '亚萨合莱(中国)投资有限公司',
          msg:'“我们通过群晖 ABB 备份套件为 11 个分部千余台办公终端构建自动化数据保护体系，实现从安装到计划备份的全流程集中管控，保障任务连续性；结合内置重删技术及零授权成本优势，较传统方案降低60% 的运维开支，成功突破大规模终端备份效能与成本双重瓶颈。”',
          person:'——亚萨合莱(中国)投资有限公司 IT 架构部门奚经理'
        },
      ],
      caseList: [
        { src: require('@/assets/img/synology-new/cgal-01.jpg'),
          title: '河南卫华重型机械股份有限公司',
          desc: '使用机型/RS3621xs+',
          msg: '群晖 NAS 向河南卫华提供了高可用集群的解决方案，帮助我们重新迁移、整理了几十万份工业设计文件，打造稳定安全的存储和高效的数据保护。群晖NAS为装备制造行业存储 提供解决方案，为其业务持续、稳定发展保驾护航。'
        },
        { src: require('@/assets/img/synology-new/cgal-02.jpg'),
          title: '漯河市卫龙商贸有限公司',
          desc: '使用机型/RS4017xs+ ',
          msg: '卫龙将两台群晖 NAS 组成高可用集群，实现双机热备，分钟级故障转移大幅提升服务运行时间以及业务连续性。群晖提供食品加工行业NAS存储解决方案，推动企业数字化转型从理念走向实践，助力生产业务稳健运行。'
        },
        { src: require('@/assets/img/synology-new/cgal-03.jpg'),
          title: '特步集团',
          desc: '使用机型/ RS2416+、RS4017xs+、 RS4021xs+ ',
          msg: '特步借助群晖打造了坚实可靠的数据管理方案，破解存储难题，加速"共享赛道"，谱写特步"非一般的感觉"，实现了资源的高效利用，降低运维成本。群晖生产制造业文件服务器为企业的发展创新提供强有力的保障。'
        },
        { src: require('@/assets/img/synology-new/cgal-04.jpg'),
          title: '华东理工大学信息学院',
          desc: '使用机型/RS3618xs',
          msg: '华东理工大学信息学院搭建群晖 NAS 作为实验数据的存储节点，为师生处理信息数据效率提升 50%。群晖NAS助力教育行业高效存储，让教学效率和质量都能大幅提升，数据安全和灾备也有了可靠保障。'
        },
        { src: require('@/assets/img/synology-new/cgal-05.jpg'),
          title: '昆明航空',
          desc: '使用机型/RS814+',
          msg: '昆明航空借助群晖集中存储 20T 非结构化文件，打破文件共享低效困境，实现跨电脑无缝共享、数据自动备份，既提升工作效率，又减轻了 IT 运维压力。群晖企业文件共享解决方案助力航空业增速提效。'
        },
        { src: require('@/assets/img/synology-new/cgal-06.jpg'),
          title: '丰田汽车（越南）',
          desc: '使用机型/ SA3410',
          msg: '丰田汽车（越南）公司通过群晖提升业务连续性，还可依据业务数据成长速度，灵活扩展存储容量。一个既能降低 IT 基础架构成本，又能为企业关键生产数据提供保护的汽车行业存储方案，正是群晖的优势所在。'
        },
      ],
      customerList: [
        { src: require('@/assets/img/synology-new/kh1.png')},
        { src: require('@/assets/img/synology-new/kh2.png')},
        { src: require('@/assets/img/synology-new/kh3.png')},
        { src: require('@/assets/img/synology-new/kh4.png')},
        { src: require('@/assets/img/synology-new/kh5.png')},
        { src: require('@/assets/img/synology-new/kh6.png')},
        { src: require('@/assets/img/synology-new/kh7.png')},
        { src: require('@/assets/img/synology-new/kh8.png')},
        { src: require('@/assets/img/synology-new/kh9.png')},
        { src: require('@/assets/img/synology-new/kh10.png')},
      ],
      ryList:[
        {img: require('@/assets/img/synology-new/ry1.svg'),
          title:'1300万+',
          desc:'全球已销售设备'
        },
        {img: require('@/assets/img/synology-new/ry2.svg'),
          title:'60%+',
          desc:'市场占有率'
        },
        {img: require('@/assets/img/synology-new/ry3.svg'),
          title:'1000+',
          desc:'全球技术支持员工'
        },
        {img: require('@/assets/img/synology-new/ry4.svg'),
          title:'6',
          desc:'全球分公司'
        },
      ],
      faList:[
        {
          img: require('@/assets/img/synology-new/banner/fa01.jpg'),
          imgText: '企业如何备份数据？',
          title:'群晖备份一体机',
          desc:'集中备份服务器、虚拟机、电脑、无需额外费用'
        },{
          img: require('@/assets/img/synology-new/banner/fa02.jpg'),
          imgText: '如何搭建文件服务器？',
          title:'安全、高效、易用是关键',
          desc:'群晖文件服务器，即时共享，无惧病毒，支持远程办公'
        },{
          img: require('@/assets/img/synology-new/banner/fa03.jpg'),
          imgText: '如何找到适合自己的NAS？',
          title:'家庭或小型办公室、商用或企业',
          desc:'Synology 产品线较为丰富，我们推荐更适合您的 NAS 服务器 '
        },{
          img: require('@/assets/img/synology-new/banner/fa04.jpg'),
          imgText: '企业异地多设备间同步协作效率低？',
          title:'跨设备异地同步 ',
          desc:'自动同步文件最新版本，异地即时共享，内置多版本备份'
        },
      ],
      activeName:'first',
      TSRMProductList:[
        {
          img: require('@/assets/img/synology-new/tashi/DS423.png'),
          title: 'DS423',
          yp: '4硬盘',
          desc1: '223 MB/s 以上的读取性能',
          desc2: '22.9 dB 低噪音',
          desc3: '支持 Btrfs 文件系统',
          flag: '0'
        },{
          img: require('@/assets/img/synology-new/tashi/DS223.png'),
          title: 'DS223',
          yp: '2硬盘',
          desc1: '四核 1.7 GHZ CPU',
          desc2: '安静节能',
          desc3: '支持 Btrfs 文件系统',
          flag: '0'
        },{
          img: require('@/assets/img/synology-new/tashi/DS124.png'),
          title: 'DS124',
          yp: '1硬盘',
          desc1: '四核 1.7 GHZ CPU',
          desc2: '安静节能',
          desc3: '支持 Btrfs 文件系统',
          flag: '0'
        },{
          img: require('@/assets/img/synology-new/tashi/DS223j.png'),
          title: 'DS223j',
          yp: '2硬盘',
          desc1: '安静节能',
          desc2: '轻松共享与同步',
          desc3: '支持 Btrfs 文件系统',
          flag: '0'
        },

      ],
      TSJJProductList:[
        {
          img: require('@/assets/img/synology-new/tashi/DS3622xs+.png'),
          title: 'DS3622xs+',
          yp: '12硬盘',
          desc1: '6 核心 2.2 GHZ CPU',
          desc2: '2x10GbE和专用带外(OOB)管理',
          desc3: '可扩充至多达 36 个硬盘',
          flag: '0'
        },{
          img: require('@/assets/img/synology-new/tashi/DS1823xs+.png'),
          title: 'DS1823xs+',
          yp: '8硬盘',
          desc1: '内置 M.2 NVMe 插槽，可用于 SSD缓存或存储池',
          desc2: '1x10GbE RJ-45 和专用带外管理',
          desc3: '可扩充至 18 个硬盘',
          flag: '0'
        },{
          img: require('@/assets/img/synology-new/tashi/DS2422+.png'),
          title: 'DS2422+',
          yp: '12硬盘',
          desc1: '四核 2.2 GHZ CPU',
          desc2: '高达 32 GB DDR4 ECC SODIMM',
          desc3: '可扩充到 24 个硬盘',
          flag: '0'
        },{
          img: require('@/assets/img/synology-new/tashi/DS1825+.png'),
          title: 'DS1825+',
          yp: '8硬盘',
          desc1: '2x2.5GbE RJ-45 端口，可选购10/25GbE 网络适配器',
          desc2: '内置 M.2 NVMe 插槽用于 SSD 缓存',
          desc3: '可扩展至 18 个硬盘',
          flag: '1'
        },{
          img: require('@/assets/img/synology-new/tashi/DS1821+.png'),
          title: 'DS1821+',
          yp: '8硬盘',
          desc1: '四核 2.2 GHZ CPU',
          desc2: '内置 M.2 NVMe 插槽，用于 SSD缓存',
          desc3: '可扩容至 18 盘位',
          flag: '2'
        },{
          img: require('@/assets/img/synology-new/tashi/DS1621+.png'),
          title: 'DS1621+',
          yp: '6硬盘',
          desc1: '四核 2.2 GHZ CPU',
          desc2: '内置 M.2 NVMe 插槽，用于 SSD 缓存',
          desc3: '可扩容至 16 盘位',
          flag: '2'
        },
        {
          img: require('@/assets/img/synology-new/tashi/DS1525+.png'),
          title: 'DS1525+',
          yp: '5硬盘',
          desc1: '2x2.5GbE RI-45 和可选的1x10GbE',
          desc2: '内置 M.2 NVMe 插槽用于 SSD 缓存或存储池',
          desc3: '可扩展至 15 个硬盘',
          flag: '1'
        },
        {
          img: require('@/assets/img/synology-new/tashi/DS1522+.png'),
          title: 'DS1522+',
          yp: '5硬盘',
          desc1: '内置 M.2 NVMe 插槽，用于 SSD 缓存',
          desc2: '4x1 GbE 和可选的1x10GbE RJ-45',
          desc3: '可扩充至 15 盘位',
          flag: '0'
        },{
          img: require('@/assets/img/synology-new/tashi/DS925+.png'),
          title: 'DS925+',
          yp: '4硬盘',
          desc1: '2x2.5GbE RJ-45 端口',
          desc2: '内置 M.2 NVMe 插槽用于 SSD 缓存或存储池',
          desc3: '可扩展至 9 块硬盘',
          flag: '1'
        },{
          img: require('@/assets/img/synology-new/tashi/DS725+.png'),
          title: 'DS725+',
          yp: '2硬盘',
          desc1: '1x2.5GbE和1x1GbE RJ-45 端囗',
          desc2: '内置 M.2 NVMe 插槽用于 SSD 缓存',
          desc3: '可扩展至 7 块硬盘',
          flag: '1'
        },{
          img: require('@/assets/img/synology-new/tashi/DS620slim.png'),
          title: 'DS620slim',
          yp: '6硬盘',
          desc1: '紧凑型 6 槽式 2.5 吋机箱',
          desc2: '双核 CPU，脉冲频率高达 2.5 GHZ',
          desc3: '可升级内存容量',
          flag: '0'
        },{
          img: require('@/assets/img/synology-new/tashi/DS425+.png'),
          title: 'DS425+',
          yp: '4硬盘',
          desc1: '1x2.5GbE和1x1GbE RJ-45 端口',
          desc2: '内置 M.2 NVMe 插槽用于SSD缓存',
          desc3: '可升级的内存容量',
          flag: '1'
        },{
          img: require('@/assets/img/synology-new/tashi/DS224+.png'),
          title: 'DS224+',
          yp: '2硬盘',
          desc1: '2x1GbE RJ-45 接口',
          desc2: '支持 Btrfs 文件系统',
          desc3: '可升级内存容量',
          flag: '2'
        }

      ],
      JJQSCProductList:[
        {
          img: require('@/assets/img/synology-new/jijiashi/FlashStation FS6400.png'),
          title: 'FS6400',
          yp: '24硬盘',
          desc1: '240,000 次4K随机写入IOPS',
          desc2: '两个八核 2.1 GHZ CPU',
          desc3: 'Synology RAID F1 闪存存储耐用性',
          flag: '0'
        },{
          img: require('@/assets/img/synology-new/jijiashi/FlashStation FS3600.png'),
          title: 'FS3600',
          yp: '24硬盘',
          desc1: '12 核 CPU，睿频加速高达 2.7 GHZ',
          desc2: '195,000 次以上iSCSl 4K 随机写入IOPS',
          desc3: '可扩充至 72个 SAS/SATA SSD',
          flag: '0'
        },{
          img: require('@/assets/img/synology-new/jijiashi/FlashStation FS3410.png'),
          title: 'FS3410',
          yp: '24硬盘',
          desc1: '129,400次以上iSCSl4K随机写入IOPS',
          desc2: '内置双 10GbE 网络接口',
          desc3: '24 个 SATA 硬盘插槽',
          flag: '0'
        },{
          img: require('@/assets/img/synology-new/jijiashi/FS2500.png'),
          title: 'FS2500',
          yp: '12硬盘',
          desc1: '超过 80,000 isCSl 4K 随机写入IOPS',
          desc2: '4核 CPU，高达 32 GB RAM',
          desc3: '12 个 SATA 硬盘插槽',
          flag: '0'
        },
      ],
      JJGKCProductList:[
        {
          img: require('@/assets/img/synology-new/jijiashi/HD6500.png'),
          title: 'HD6500',
          yp: '60硬盘',
          desc1: '双 10 核 CPU，睿频高达 3.2 GHZ',
          desc2: '多达 300 个硬盘插槽',
          desc3: '连续读写性能可达 6,688/6,662MB/s 以上',
          flag: '0'
        },{
          img: require('@/assets/img/synology-new/jijiashi/SA6400.png'),
          title: 'SA6400',
          yp: '12硬盘',
          desc1: '搭配8台 RX1223RP 扩充设备可提供多达 1.944 PB 存储空间',
          desc2: '6,500/4,000 MB 以上的连续读写效能',
          desc3: '通过 PCle 3.0 扩充实现可选的25/40GbE 或 FC 光纤通道',
          flag: '0'
        },{
          img: require('@/assets/img/synology-new/jijiashi/SA3610 & SA3410.png'),
          title: 'SA3610',
          yp: '12硬盘',
          desc1: '12 核 CPU，睿频加速高达 2.7 GHZ',
          desc2: '搭配 7 台 RX1222sas 扩充设备可提供多达 1.728 PB 存储空间',
          desc3: '6,200/3,000 MB 以上的连续读写效能',
          flag: '0'
        },{
          img: require('@/assets/img/synology-new/jijiashi/SA3610 & SA3410.png'),
          title: 'SA3410',
          yp: '12硬盘',
          desc1: '八核 CPU，睿频加速高达 2.7 GHZ',
          desc2: '搭配7台 RX1222sas 扩充设备可提供多达 1.728 PB 存储空间',
          desc3: '6,200/3,000 MB 以上的连续读写效能',
          flag: '0'
        },{
          img: require('@/assets/img/synology-new/jijiashi/SA3400D.png'),
          title: 'SA3400D',
          yp: '12硬盘',
          desc1: '双控制器架构',
          desc2: '超过 130,000 4K随机写入IOPS',
          desc3: '超过 500 TB 储存容量上限',
          flag: '0'
        },{
          img: require('@/assets/img/synology-new/jijiashi/SA3200D.png'),
          title: 'SA3200D',
          yp: '12硬盘',
          desc1: '双控制器架构',
          desc2: '四核 CPU，睿频加速高达 2.7 GHZ',
          desc3: '90,000 次以上 4K 随机写入 IOPS',
          flag: '0'
        },
      ],
      JJTYCCProductList:[
        {
          img: require('@/assets/img/synology-new/jijiashi/RS4021xs+.png'),
          title: 'RS4021xs+',
          yp: '16硬盘',
          desc1: '提供超过 234,698 4K 随机读取IOPS',
          desc2: '内置双 10GbE 网口',
          desc3: '搭配 RX1217RP/RX1217 扩充至 40个硬盘插槽',
          flag: '0'
        },{
          img: require('@/assets/img/synology-new/jijiashi/RS3621xs+.png'),
          title: 'RS3621xs+',
          yp: '12硬盘',
          desc1: 'Intel® 八核处理器',
          desc2: '内置双 10GbE 网口',
          desc3: 'DDR4 ECC UDIMM 内存可扩充至64 GB',
          flag: '2'
        },{
          img: require('@/assets/img/synology-new/jijiashi/RS3621xs+.png'),
          title: 'RS3621RPxs',
          yp: '12硬盘',
          desc1: 'Intel@六核处理器',
          desc2: '双 PCle 插槽',
          desc3: '冗余电源',
          flag: '2'
        },{
          img: require('@/assets/img/synology-new/jijiashi/RS3618xs.png'),
          title: 'RS3618xs',
          yp: '12硬盘',
          desc1: '四核 2.4 GHZ CPU',
          desc2: '可扩充至 36 个硬盘',
          desc3: '内存可扩充至 64 GB',
          flag: '0'
        },{
          img: require('@/assets/img/synology-new/jijiashi/RS1619xs+.png'),
          title: 'RS1619xs+',
          yp: '4硬盘',
          desc1: '四核 2.2 GHZ CPU',
          desc2: '可选 10GbE 支持',
          desc3: '内置 M.2 NVMe 插槽，用于 SSD 缓存',
          flag: '0'
        },{
          img: require('@/assets/img/synology-new/jijiashi/RS2825RP+.png'),
          title: 'RS2825RP+',
          yp: '16硬盘',
          desc1: '超过 3,519/1,790 MB/s 的顺序读写速度',
          desc2: '内置 10GbE 网络端口，并可额外扩充 10/25GbE',
          desc3: '可扩展至 28 个硬盘',
          flag: '1'
        },{
          img: require('@/assets/img/synology-new/jijiashi/RS2423RP+RS2423+.png'),
          title: 'RS2423RP+',
          yp: '12硬盘',
          desc1: '3500/1700 MB/S 以上的连续读写性能',
          desc2: '可扩充到 24 个硬盘',
          desc3: '内置 1/10GbE，具有 1/10/25GbE扩展选项',
          flag: '2'
        },{
          img: require('@/assets/img/synology-new/jijiashi/RS2423RP+RS2423+.png'),
          title: 'RS2423+',
          yp: '12硬盘',
          desc1: '3500/1700 MB/S 以上的连续读写性能',
          desc2: '可扩充到 24 个硬盘',
          desc3: '内置 1/10GbE，具有 1/10/25GbE扩展选项',
          flag: '0'
        },{
          img: require('@/assets/img/synology-new/jijiashi/RS1221RP+RS1221+.png'),
          title: 'RS1221RP+',
          yp: '8硬盘',
          desc1: '四核 2.2 GHZ CPU',
          desc2: '可扩充至 12 个硬盘',
          desc3: '可选10GbE 支持',
          flag: '0'
        },{
          img: require('@/assets/img/synology-new/jijiashi/RS822RP+RS822+.png'),
          title: 'RS822RP+',
          yp: '4硬盘',
          desc1: '连续读/写性能可达每秒 2103/1074MB 以上',
          desc2: '2 GB DDR4 ECC(至多 32 GB)',
          desc3: '内置4个 1GbE 接口，同时能利用10/25 GbE 进行扩充',
          flag: '0'
        },{
          img: require('@/assets/img/synology-new/jijiashi/RS822RP+RS822+.png'),
          title: 'RS822+',
          yp: '4硬盘',
          desc1: '连续读/写性能可达每秒 2103/1074MB 以上',
          desc2: '2 GB DDR4 ECC(至多 32 GB)',
          desc3: '内置4个 1GbE 接口，同时能利用10/25 GbE 进行扩充',
          flag: '0'
        },{
          img: require('@/assets/img/synology-new/jijiashi/RS422+.png'),
          title: 'RS422+',
          yp: '4硬盘',
          desc1: '连续读取性能可达 590 MB/S 以上',
          desc2: '1U 存储，设计小巧，12 英寸深度',
          desc3: '支持10GbE',
          flag: '0'
        },{
          img: require('@/assets/img/synology-new/jijiashi/UC3400.png'),
          title: 'UC3400',
          yp: '12硬盘',
          desc1: '双活控制器可尽可能延长 iscSl 服务正常运行时间',
          desc2: '八核 CPU，睿频加速高达 2.7 GHZ',
          desc3: '180,000 次以上的iscSI 4K 随机写入IOPS',
          flag: '0'
        },{
          img: require('@/assets/img/synology-new/jijiashi/UC3200.png'),
          title: 'UC3200',
          yp: '12硬盘',
          desc1: '活动-活动控制器可尽可能延长 iSCSI服务正常运行时间',
          desc2: '四核 CPU，睿频加速高达 2.7 GHZ',
          desc3: '140,000 次以上isCSl 4K 随机写入IOPS',
          flag: '0'
        },
      ]
    }
  },
  mounted() {
    this.activeName="first"
    let elements = document.querySelectorAll('.synology-tab-area');
    window.onscroll = () => {
      if(document.documentElement.scrollTop > 620){
        elements.forEach(function(element) {
          element.classList.add('synology-tab-area-fixed');
        });
        if(document.documentElement.scrollTop < 1100){
          this.activeName="first"
        }
        if(document.documentElement.scrollTop > 1100){
          this.activeName="second"
        }
        if(document.documentElement.scrollTop > 1600){
          this.activeName="third"
        }
        if(document.documentElement.scrollTop > 4500){
          this.activeName="fourth"
        }
        if(document.documentElement.scrollTop > 6000){
          this.activeName="five"
        }
        if(document.documentElement.scrollTop > 6600){
          this.activeName="six"
        }
      }else {
        this.activeName="first"
        elements.forEach(function (element) {
          element.classList.remove('synology-tab-area-fixed');
        });
      }
    }
  },

  methods: {
    changeSecondLevel(){
      if(this.secondLevel==="1"||this.secondLevel==="2"){
        this.firstLevel = '1';
      } else if(this.secondLevel==="3"||this.secondLevel==="4"||this.secondLevel==="5"){
        this.firstLevel = '2';
      }
    },
    setFirstLevel(flag){
      this.firstLevel = flag;
      this.secondLevel = '';
    },
    changeFirstLevel(){
      this.secondLevel = '';
      // console.log("111")
    },
    toZixun(){
      this.centerDialogVisible = true;
      this.captchaDialogVisible = false;
    },
    toSubmit(){
      // if(!this.name){
      //   this.$message({
      //     message: '<div style="font-size: 0.8rem;padding: 5PX">请填写姓名</div>',
      //     type: 'warning',
      //     dangerouslyUseHTMLString: true,
      //     customClass: 'custom-message-class'
      //   });
      //   return false
      // }
      if(!this.phone){
        this.$message({
          message: '<div style="font-size: 0.8rem;padding: 5PX">请填写联系手机</div>',
          type: 'warning',
          dangerouslyUseHTMLString: true,
          customClass: 'custom-message-class'
        });
        return false
      }
      // if(!this.company){
      //   this.$message({
      //     message: '<div style="font-size: 0.8rem;padding: 5PX">请填写公司名称</div>',
      //     type: 'warning',
      //     dangerouslyUseHTMLString: true,
      //     customClass: 'custom-message-class'
      //   });
      //   return false
      // }
      // if(!this.remark){
      //   this.$message({
      //     message: '<div style="font-size: 0.8rem;padding: 5PX">请填写需求内容</div>',
      //     type: 'warning',
      //     dangerouslyUseHTMLString: true,
      //     customClass: 'custom-message-class'
      //   });
      //   return false
      // }
      // if(!this.type){
      //   this.$message({
      //     message: '<div style="font-size: 0.8rem;padding: 5PX">请选择合作方式</div>',
      //     type: 'warning',
      //     dangerouslyUseHTMLString: true,
      //     customClass: 'custom-message-class'
      //   });
      //   return false
      // }
      console.log(this.checkList.join("；"))
      this.captchaCode = ''
      this.getCaptcha();
      this.captchaDialogVisible = true;
    },
    getCaptcha() {
      this.axios.get(window.location.origin + '/website-api/login/getCaptcha')
          .then((res) => {
            this.captchaBase64Image = res.data.data.captchaBase64Image;
            this.captchaUuid = res.data.data.captchaUuid;
            this.beginRefreshCaptchaInterval(res.data.data.expireSeconds);
          })
          .catch((err) => {
            console.log(err.message)
          })
    },

    beginRefreshCaptchaInterval(expireSeconds) {
      console.log(expireSeconds,"expireSeconds")
      if (this.refreshCaptchaInterval === null && expireSeconds > 0) {
        this.captchaCode=""
        this.refreshCaptchaInterval = setInterval(this.getCaptcha, (expireSeconds - 5) * 1000);
      }
    },

    stopRefreshCaptchaInterval() {
      if (this.refreshCaptchaInterval != null) {
        clearInterval(this.refreshCaptchaInterval);
        this.refreshCaptchaInterval = null;
      }
    },
    handleClick(){
      if(this.activeName==="first"){
        const element = document.getElementById('ljqh');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' ,block: 'center'});
        }
        setTimeout(() => {
          this.activeName="first"
        },500)
      }
      if(this.activeName==="second"){
        const element = document.getElementById('hxgn');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' ,block: 'start'});
        }
        setTimeout(() => {
          this.activeName="second"
        },500)
      }
      if(this.activeName==="third"){
        const element = document.getElementById('gnys');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' ,block: 'start'});
        }
        setTimeout(() => {
          this.activeName="third"
        },500)
      }
      if(this.activeName==="fourth"){
        const element = document.getElementById('cpxh');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' ,block: 'start'});
        }
        setTimeout(() => {
          this.activeName="fourth"
        },500)
      }
      if(this.activeName==="five"){
        const element = document.getElementById('sqzs');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' ,block: 'start'});
        }
        setTimeout(() => {
          this.activeName="five"
        },500)
      }
      if(this.activeName==="six"){
        const element = document.getElementById('fwkh');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' ,block: 'start'});
        }
        setTimeout(() => {
          this.activeName="six"
        },500)
      }
    },
    onSubmit() {
      if(!this.captchaCode){
        this.$message({
          message: '验证码不能为空',
          type: 'warning'
        });
        return false
      }
      let fromData = {
        name: this.name,
        phone: this.phone,
        company: this.company,
        remark: this.remark,
        type: this.checkList.join("；"),
        captchaCode: this.captchaCode,
        captchaUuid: this.captchaUuid
      }
      this.axios.post(window.location.origin + '/website-api/websiteMessage/add',fromData)
      .then((res) => {
        console.log(res.data)
        if(res.data.code === 0){
          this.$message({
            message: '留言成功，我们将在1到2个工作日内与您联系',
            type: 'success'
          });
          this.centerDialogVisible = false;
          this.captchaDialogVisible = false;
          this.reset()
          this.stopRefreshCaptchaInterval();
        }else{
          this.$message({
            message: res.data.msg,
            type: 'error'
          });
        }
      })
      .catch((err) => {
        console.log(err.message)
      })

    },
    reset() {
      // this.centerDialogVisible = false;
      this.name = '';
      this.phone = '';
      this.company = '';
      this.remark = '';
      this.type = '';
      this.captchaCode = '';
      this.captchaUuid = '';
    },
  },
}
</script>

<style lang="scss" scoped >
.sy-dialog{
  width: 1400px;
  margin: auto;
  @media screen and (max-width: 768px) {
    width: 100%;
    margin: auto;
  }
  .dialog-title{
    font-size: 20px;
    color: #383838;
    text-align: center;
    line-height: 30px;
    font-weight: bold;
    @media screen and (max-width: 768px) {
      font-size: 1.1rem;
      line-height: 1.4rem;
    }
  }
  .dialog-desc{
    font-size: 16px;
    color: #808080;
    text-align: center;
    line-height: 50px;
    margin-bottom: 10px;
    @media screen and (max-width: 768px) {
      font-size: 0.8rem;
      line-height: 1.8rem;
      margin-bottom: 10PX;
    }
  }
}
::v-deep(.el-dialog__headerbtn){
  @media screen and (max-width: 768px) {
    font-size: 1rem;
    padding: 2PX;
  }
}
::v-deep(.el-dialog__header){
  @media screen and (max-width: 768px) {
    padding: 10PX;
  }
}
::v-deep(.el-dialog--center){
  @media screen and (max-width: 768px) {
    width: 95%;
    border-radius: 4PX;
  }
}
.sy-zixun{
  background-color: #F2F8FF !important;
  border-radius: 4px !important;
  @media screen and (max-width: 768px) {
    background-color: #fff !important;
    border-radius: 4PX !important;
    //box-shadow: 0 1px 4px rgba(12, 28, 56, 0.1);/**/
  }
}
.sy-hxgn{
  background-color: #F5F7FA;
  @media screen and (max-width: 768px) {
    background-color: #fff;
  }
}
.lj-text{
  color: rgba(128, 128, 128, 1);
  font-size: 0.75rem;
  line-height: 1.2rem;
  padding: 0 5PX;
}
.captcha-img{
  width: 100%;
  cursor: pointer;
  margin-bottom: 5px;
}
.input-style{
  margin-bottom: 20px;
  @media screen and (max-width: 768px) {
    margin-bottom:10PX;
    padding: 10PX 10px 0PX 10PX;
  }
  img{
    width: 16px;
    @media screen and (max-width: 768px) {
      width:10PX;margin: 0 5PX;
    }
  }
  .in-line{
    margin-top: -5px;
    margin-left:12px;
    width: 1px;
  }

}
.radio-style-sy{
  text-align: left;
  margin-bottom: 20px;
  font-size: 14px;
  font-weight: bold;
  //padding-left: 10px;
  line-height: 30px;
  color: #383838;
  .checkbox-title{
    margin-bottom: 10PX;
  }
  :deep(.el-checkbox__label){
    color: #999999;
    font-weight: normal;
    /* 或者使用 overflow-wrap */
    //white-space: normal !important;
    @media screen and (max-width: 768px) {
      font-size: 0.7rem;
      line-height: 18PX;
    }
  }
  :deep(.el-checkbox__inner::after ){
    @media screen and (max-width: 768px) {
      margin-left: 2PX;
      margin-top: -1PX;
      width: 4PX;
      height: 7PX;
    }
  }
  :deep(.el-checkbox__inner){
    @media screen and (max-width: 768px) {
      margin-top: -6PX;
      margin-right: 5PX;
      width: 12PX;
      height: 12PX;
    }
  }
  :deep(.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner) {
    background-color: #0052d9;
    border-color: #0052d9;
  }
  @media screen and (max-width: 768px) {
    font-size: 0.7rem;
    margin-left: 10PX;
    line-height: 15PX;
  }
  .radio-title{
    margin-top: -5px;
    margin-left:12px;
    width: 100px;
  }

}
::v-deep(.el-radio__label) {

  @media screen and (max-width: 768px) {
    font-size: 0.7rem;
  }
}
::v-deep(.el-radio__input.is-checked+.el-radio__label) {
    color: #0052D9;
}

::v-deep(.el-radio__inner) {
  font-weight: normal !important;
  @media screen and (max-width: 768px) {
    width: 10PX;
    height: 10PX;
    margin-top: -6PX;
    margin-right: 4PX;
  }
}
::v-deep(.el-radio__input.is-checked .el-radio__inner) {
  border-color: #0052D9;
  background: #0052D9;

}
::v-deep(.el-dialog__title) {
  @media screen and (max-width: 768px) {
    font-size: 0.7rem !important;
  }
}
::v-deep(.el-button){
  @media screen and (max-width: 768px) {
    font-size: 0.7rem !important;
    line-height: 1.5rem;
    padding: 0 10PX;
    border-radius: 3PX;
    margin: 10PX 10PX;
  }
}
::v-deep(.el-input-group__prepend) {
  background-color: #fff !important;
  border-right: 0;
}
::v-deep(.el-input__inner) {
  @media screen and (max-width: 768px) {
    font-size: 0.7rem;
    height: 2rem;
  }
}
.liaojie-img{
  width: 100%;
  margin: 20px auto 40px auto;
}
.demo_wrap {
  width: 100%;
  margin-top: 70px;
  @media screen and (max-width: 768px) {
    background-color: #f5f7fa;
  }

  .hzhb {
    width: 100%;

    img {
      width: 100%;
    }
  ;
  }
  .submit {
    margin-top: 20px;
    width: 200px;
    background-color: #00A4FF;
    font-size: 18px;
  }

  .reset {
    margin-top: 20px;
    margin-left: 20px;
    background-color: rgb(255 255 255 / 30%);
    border-color: rgb(255 255 255 / 30%);
    color: #fff;
    width: 200px;
    font-size: 18px;

  }
  .sy-contact{
    width: 100%;
    //cursor: pointer;
    height: 300px;
    background: url('../../assets/img/synology/contact-bg.jpg') 0 0 no-repeat;
    background-size: 100% 100%;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    position: relative;
    @media screen and (max-width: 768px) {
      height: 40vw;
      width: 95%;
      margin: auto;
      border-radius: 5PX;
    }
    .sq-title{
      color: #fff;
      text-align: center;
      font-size: 32px;
      font-weight: bold;
      @media screen and (max-width: 768px) {
        font-size: 1.1rem;
        margin-bottom: 5PX;
      }
    }
    .sq-desc{
      color: #fff;
      font-size: 20px;
      text-align: center;
      margin-top: 10px;
      @media screen and (max-width: 768px) {
        font-size: 0.8rem;
        margin-top: 5PX;
      }
    }
    .ljzx{
      width: 160px;
      margin-top: 20px;
      color: #0052D9;font-size: 14px;

      @media screen and (max-width: 768px) {
        font-size: 0.8rem;
        width: 110PX;
        margin-top: 20PX;
        line-height: 1.5rem;
        border-radius: 4PX;
      }
    }
  }
  .khkf {
    width: 100%;
    //cursor: pointer;
    height: 380px;
    margin-top: 40px;
    background: url('../../assets/img/synology-new/khkf-bg.jpg') 0 0 no-repeat;
    background-size: 100% 100%;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    position: relative;
    text-align: center;
    font-size: 13px;
    @media screen and (max-width: 768px) {
      height: 600PX;
    }
    .khkf-center-area{
      width: 800px;
      margin: auto;
      padding-top: 70px;
      letter-spacing: 1px;
      @media screen and (max-width: 768px) {
        width: 80%;
      }
      .person{
        margin-top: 30px;
      }
      .title{
        font-size: 24px;
        margin-bottom: 30px;
      }
      .msg{
        line-height: 24px;
      }
    }
  }
    .shouquan{
    width: 100%;
    //cursor: pointer;
    height: 400px;
    background: url('../../assets/img/synology-new/rybg.jpg') 0 0 no-repeat;
    background-size: 100% 100%;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    position: relative;
    @media screen and (max-width: 768px) {
      height: 280PX;
      background-size: cover ;
      background-position: 45% 100%;
    }
    .sq-title{
      color: #fff;
      text-align: center;
      font-size: 32px;
      font-weight: bold;
      @media screen and (max-width: 768px) {
        font-size: 1rem;
      }
    }
    .sq-desc{
      color: #fff;
      font-size: 20px;
      text-align: center;
      margin-top: 10px;
      @media screen and (max-width: 768px) {
        font-size: 0.7rem;
        line-height: 1.5rem;
      }
    }
    .img-area{
      display: flex;
      align-items: center;
      align-content: center;
      justify-content: space-between;
      @media screen and (max-width: 768px) {
        justify-content: space-around;
        display: block;
      }
      .img-item{
        flex-direction: column;
        text-align: center;
        @media screen and (max-width: 768px) {
          width: 50%;
          padding-top: 10PX;
        }
        img{
          height: 36px;
          @media screen and (max-width: 768px) {
            height: 32PX;
          }
        }
        .line{
          background-color:#0052d9;
          width: 26px;
          margin: 12px auto;
          @media screen and (max-width: 768px) {
            width: 20PX;
            margin: 5PX auto;
          }
        }
        .number{
          font-size: 20px;
          color: #fff;
          font-weight: bold;
          margin-top: 10px;
          @media screen and (max-width: 768px) {
            font-size: 1.0rem;
            margin-top: 5PX;
          }
        }
        .desc{
          font-size:14px ;
          color: #fff;
          line-height: 20px;
          @media screen and (max-width: 768px) {
            font-size: 0.7rem;
            line-height: 1.2rem;
            margin-bottom: 10PX;
          }
        }
      }
    }


  }

  .demo_title_wrap {
    text-align: center;
    @media screen and (max-width: 768px) {
      text-align: left;
    }

    h1 {
      font-size: 32px;
      @media screen and (max-width: 768px) {
        font-size: 28px;
      }
    }

    p {
      font-size: 18px;
      margin-top: 10px;
      @media screen and (max-width: 768px) {
        font-size: 16px;
        margin-top: 10px;
      }
    }
  }
}
.center-area{
  width: 70%;
  margin: auto;
  @media screen and (max-width: 768px) {
    width: 95%;
    margin-top: 10PX;
  }

  .tab-content{
    margin-bottom: 120px;
    //@media screen and (max-width: 768px) {
    //  width: 95%;
    //  margin-bottom: 50PX;
    //}
    .el-radio-group {
      width: 80%;
      margin:40px auto 20px auto;
      display: flex;
      justify-content: space-between;
      @media screen and (max-width: 768px) {
        width: 100%;
      }
    }
    ::v-deep(.el-radio-button:first-child .el-radio-button__inner) {
      border-radius: 0 !important;
    }
    ::v-deep(.el-radio-button:last-child .el-radio-button__inner) {
      border-radius: 0 !important;
    }
    ::v-deep(.el-radio-button__orig-radio:checked+.el-radio-button__inner){
      background-color: #0052D9 !important;
      border: 1px solid #0052D9 !important;
    }
    ::v-deep(.el-radio-button) {
      width: calc(100%/6 - 4px);
      text-align: center;
      @media screen and (max-width: 768px) {
        width: calc(100%/3 - 4px);
      }
    }
    ::v-deep(.el-radio-button__inner) {
      width: 90%;
      margin: auto;
      background-color: #F2F2F2;
      border: 1px solid #F2F2F2;
      -webkit-box-shadow: unset;
      box-shadow: unset;
      padding: 14px;
      @media screen and (max-width: 768px) {
        padding: 7PX;
        font-size: 0.8rem;
      }
    }
    .half-inner{
      width:12.5%;
      float: left;
      ::v-deep(.el-radio-button) {
        width: 100% !important;
        text-align: right;
      }
      .el-radio-group {
         width: 100%;
        //float: left;
      }


    }
    .half-inner-middle{
      width:100%;
      float: left;
      ::v-deep(.el-radio-button) {
        width: calc(100%/2 - 4px) !important;
        text-align: center;
        @media screen and (max-width: 768px) {
          width: 100%;
          padding-top: 2PX;
        }
      }
      .el-radio-group {
         width: 100%;
      }
      ::v-deep(.el-radio-button__orig-radio:checked+.el-radio-button__inner){
        background-color: #fff !important;
        color: #0052d9;
        border: 1px solid #fff !important;
      }

      ::v-deep(.el-radio-button__inner) {
        width: 90%;
        margin: auto;
        background-color: #fff;
        border: 1px solid #fff;
        -webkit-box-shadow: unset;
        box-shadow: unset;
        padding: 14px;
      }
    }
    .half-inner-right{
      width:100%;
      float: left;
      //@media screen and (max-width: 768px) {
      //  width: 100%;
      //}
      ::v-deep(.el-radio-button) {
        width: calc(100%/3 - 6px) !important;
        text-align: center;

        @media screen and (max-width: 768px) {
          width: 100%;
          padding-top: 10PX;
          padding-bottom: 20PX;
        }
      }
      .el-radio-group {
         width: 100%;
      }
      ::v-deep(.el-radio-button__orig-radio:checked+.el-radio-button__inner){
         background-color: #fff !important;
          color: #0052d9;
         border: 1px solid #fff !important;
       }

      ::v-deep(.el-radio-button__inner) {
        width: 90%;
        margin: auto;
        background-color: #fff;
        border: 1px solid #fff;
        -webkit-box-shadow: unset;
        box-shadow: unset;
        padding: 14px;
      }
    }

  }
}
.hx-title{
  padding-top: 40px;
  font-size: 30px;
  color: rgba(5, 16, 47, 1);
  line-height: 40px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 20px;
  @media screen and (max-width: 768px) {
    font-size: 1.0rem;
    padding-top: 10PX;
    line-height: 2rem;
  }
}
.row-div{
  width: 100%;
  padding-bottom: 30px;
  @media screen and (max-width: 768px) {
    padding-top: 10PX;
  }

}
.hx-desc{
  font-size: 14px;
  color: #808080;
  line-height: 24px;
  text-align: center;
  @media screen and (max-width: 768px) {
    font-size: 0.7rem;

    line-height: 1.2rem;
  }
}
.height1{
  height: 550px;
  @media screen and (max-width: 768px) {
    height: auto;
    margin-bottom: 10PX;
  }
}
.height2{
  height: 640px;
  @media screen and (max-width: 768px) {
    height: auto;
    margin-bottom: 10PX;
  }
}
.height3{
  height: 500px;
  @media screen and (max-width: 768px) {
    height: auto;
    margin-bottom: 10PX;
  }
}
.height4{
  height: 350px;
  @media screen and (max-width: 768px) {
    height: auto;
    margin-bottom: 10PX;
  }
}
.height5{
  height: 480px;
  @media screen and (max-width: 768px) {
    height: auto;
    margin-bottom: 10PX;
  }
}
.hx-text{
  padding: 20px 20px 20px 15px;
  @media screen and (max-width: 768px) {
    padding: 10PX 10PX 10PX 10PX;
  }
  .title-sub1{
    color: #05102F;
    font-size: 26px;
    font-weight: bold;
    @media screen and (max-width: 768px) {
      font-size: 1.2rem;
    }
  }
  .title-sub2{
    color: #808080;
    font-size: 16px;
    margin-top: 15px;
    @media screen and (max-width: 768px) {
      font-size: 0.8rem;
      line-height: 1.2rem;
    }
  }
}
.hx-btn{
  background-color: #0052D9;
  margin-top: 20px;
  font-size: 14px;
  @media screen and (max-width: 768px) {
    font-size: 0.7rem;
    width: 180PX;
    line-height: 1.8rem;
    border-radius: 50PX;
    margin-top: 20PX;
  }
}
.hx-content-height1{
  @media screen and (max-width: 768px) {
    height: auto !important;
  }
}
.hx-content-height2{
  @media screen and (max-width: 768px) {
    height: auto;
  }
}
.hx-content{
  margin-top: 30px;
  //height: 86px;
  border-left: 5px solid rgb(0, 82, 217,0.6);
  padding-left: 10px;
  @media screen and (max-width: 768px) {
    margin-top: 15PX;
    height: auto;
    border-left: 3PX solid rgb(0, 82, 217,0.6);
    padding-left: 10PX;
  }
  .line{
    display: none;
    float: left;
    height: 100%;
    width: 4px;
    background-color: rgb(0, 82, 217,0.6);
    margin-right: 10px;
    @media screen and (max-width: 768px) {
      height: 90PX;
      width: 2PX;
      margin-right: 10PX;
      display: none;
    }
  }
  &:hover{
    border-color: rgb(0, 82, 217, 1);;
    .line {
      background-color: rgb(0, 82, 217, 1);
    }
    .title {
      color: rgb(0, 82, 217, 1);
      font-weight: bold;
    }
  }
  .title-sy{
    color: #05102F;
    font-size: 20px;
    margin-bottom: 5px;
    @media screen and (max-width: 768px) {
      font-size: 0.85rem;
      line-height: 1.5rem;
    }

  }
  .desc{
    color: rgb(128, 128, 128);
    font-size: 14px;
    padding-bottom: 5px;
    @media screen and (max-width: 768px) {
      font-size: 0.7rem;
      line-height: 1.2rem;
    }
  }
}
.hx-img{
  align-content: center;
  align-items: center;
  text-align: center;
  display: grid;
  @media screen and (max-width: 768px) {
    margin-bottom: 20PX;
  }
  img{
    width: 95%;
    //border-radius: 10px;
    @media screen and (max-width: 768px) {
      width: 100%;
      border-radius: 6PX;
    }
  }
}
.center-row{
  background-color:#fff ;
  margin: 10px 0 40px 0;
  border-radius: 4px;
  padding: 40px;
  @media screen and (max-width: 768px) {
    padding: 10PX;
    margin: 20PX 0 20PX 0;
  }
  .center-row-title{
    font-size: 24px;
    color: #05102F;
    margin-bottom: 20px;
    @media screen and (max-width: 768px) {
      font-size: 0.9rem;
      line-height: 1.2rem;
    }
  }
  .center-row-desc{
    font-size: 14px;
    line-height: 26px;
    color: #8491AB;
    @media screen and (max-width: 768px) {
      font-size: 0.6rem;
      line-height: 1.2rem;
    }
  }
  .center-row-line{
    height: 110px;
    width: 1px;
    background-color: #D9DEE4;

  }
  .center-row-img{
    width: 130px;
    float: right;
    @media screen and (max-width: 768px) {
      width: 80PX;
    }
  }

}
::v-deep(.el-tabs__nav-wrap::after){
  background-color: #fff !important;
}
::v-deep(.el-tabs__item ){
  margin-bottom: 5px;
}
::v-deep(.el-tabs__item.is-active ){
  color: #0052D9  !important;
}
::v-deep(.el-tabs__active-bar){
  background-color: transparent  !important;
  height: 3px;
}
::v-deep(.el-tabs__nav-wrap::after) {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 0.10417vw;
  background-color: transparent;
  z-index: 1;
}
.youshi-row{
  margin-top: 20px;
  text-align: center;
  padding-bottom: 30px;
  @media screen and (max-width: 768px) {
    //width: 95%;
    margin-top: 10PX;
    padding-bottom: 15PX;
  }
  .ys-card{
    margin: 10px 0;
    border-radius: 6px;
    padding: 20px 40px;
    height: 320px;
    @media screen and (max-width: 768px) {
      height: 230PX;
      padding: 10PX 10PX;
      margin: 5PX 0;
      box-shadow: 5PX 5PX 12PX 1PX rgba(12, 28, 56, 0.06);
      border-radius: 4PX;
    }
    img{
      width: 80px;
      @media screen and (max-width: 768px) {
        width: 50PX;
      }
    }
    &:hover{
      box-shadow: 0.26042vw 0.26042vw 0.625vw 1px rgb(12 28 56 / 17%);
      .ys-title{
        color: #0052D9;
        font-weight: bold;
      }
      img{
        transition: transform 0.6s ease;
        //transform: rotateY(360deg) scale(1);
      }
    }
  }
  .ys-title{
    color: rgb(5, 16, 47) ;
    font-size: 20px;
    padding: 20px;
    @media screen and (max-width: 768px) {
      font-size: 0.8rem;
      line-height: 2rem;
      padding: 10PX;
    }

  }
  .support-item{
    &:hover{
      box-shadow: 0 0 10px 6px rgba(0, 0, 0, .2);
    }
  }
  .ys-height{
    height: 80px;
  }
  .ys-btn-area{
    &:hover{
      .arrow{
        margin-left:10px;
      }
    }
  }
  .ys-desc{
    color: rgb(128, 128, 128);
    line-height: 24px;
    font-size: 14px;
    padding: 0 20px 20px 20px;
    @media screen and (max-width: 768px) {
      font-size: 0.7rem;
      line-height: 1.2rem;
      padding: 0 10PX 10PX 10PX;
    }
  }
}
.ys-btn{
  background-color: #0052D9;
  margin-top: 20px;
  width: 180px;
  font-size: 14px;
  @media screen and (max-width: 768px) {
    margin-top: 20PX;
    width: 120PX;
    font-size: 0.8rem;
    border-radius: 50PX;
    line-height: 1.8rem;
    margin-bottom: 10PX;
  }
}
::v-deep(.el-image){
  height: 340px !important;
  width: 250px !important;
  @media screen and (max-width: 768px) {
    height: 230PX !important;
    width: 170px !important;
  }
}
.flex-container {
  padding-bottom: 20px;
  margin: 30px 0 0px 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start; /* 或者使用 space-between, space-around 等 */
  @media screen and (max-width: 768px) {
    justify-content: center;
  }
  .item {
    width: calc(100% / 5 - 10px); /* 减去间距 */
    margin: 5px; /* 可根据需要调整 */
    box-sizing: border-box; /* 确保宽度包含padding和border */
    border-radius: 2px;
    @media screen and (max-width: 768px) {
      width: calc(100% / 3 - 4px); /* 减去间距 */
    }
  }
}
.flex-container-fa {
  padding-bottom: 20px;
  margin: 5px 0 0px 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between; /* 或者使用 space-between, space-around 等 */
  @media screen and (max-width: 768px) {
    justify-content: center;
  }
  .item {
    width: calc(100% / 4 - 3px); /* 减去间距 */
    //margin: 5px; /* 可根据需要调整 */
    box-sizing: border-box; /* 确保宽度包含padding和border */
    border-radius: 2px;
    @media screen and (max-width: 768px) {
      width: calc(100% / 3 - 4px); /* 减去间距 */
    }
    .el-card{
      border-radius: 0 !important;
    }
    .image{
      width: 100%;
      height: 260px;
    }
    .fa-text{
      height: 90px;
      text-align: center;
      padding-top: 10px;
      .fa-title{
        font-size: 14px;
        font-weight: bold;
        line-height: 40px;
      }
      .fa-desc{
        font-size: 14px;
      }

    }
    .bg-mask{
      background-color: rgba(0,0,0,0.4);
      height: 272px;
      width: 100%;
      position:relative;
      margin-top: -274px;
      color: #fff;
      display:flex;justify-content: center;
      align-items: center;
      flex-direction: column;
      font-size: 18px;
      font-weight: bold;
      .fa_btn{
        background-color: #0052D9;
        border-color: #0052d9;
        margin-top: 20px;
        padding-top: 10px;
        padding-bottom: 10px;
        display: none;
      }
    }
    &:hover {
      .image{
        transform: scale(1.1);
        transition: transform 0.3s ease;
      }
      .fa-text{
        position: relative;
        height: 100px;
        transition: transform 0.3s ease;
        margin-top: -10px;
        background-color: #fff;
      }
      .bg-mask{
        background-color: rgba(0,0,0,0.7);
        .fa_btn{
          display: block;
        }
      }
    }
  }
}

.flex-container-product {

  //padding-bottom: 20px;
  margin: 0px 0 0px 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: start; /* 或者使用 space-between, space-around 等 */
  @media screen and (max-width: 768px) {
    justify-content: space-between;
    margin: auto;
    width: 100%;
    ::v-deep(.el-card) {
      border: 0;
    }
  }

  .item {
    background-color: #F0F2F5;
    width: calc(100% / 4 - 12px); /* 减去间距 */
    margin: 3px; /* 可根据需要调整 */
    //margin-bottom: 7px;
    box-sizing: border-box; /* 确保宽度包含padding和border */
    border-radius: 2px;
    @media screen and (max-width: 768px) {
      width: calc(100% / 2 - 24PX); /* 减去间距 */
      margin: 10PX;
      background-color: #fff;
    }
    .el-card{
      border-radius: 0 !important;
      background-color: #F0F2F5;
    }
    .image{
      width: 100%;
    }
    .pro-text{
      padding: 20px;
      color: #2E3742;
      @media screen and (max-width: 768px) {
        background-color: #fff;
        padding: 10PX 5PX;
      }

      .pro-title{
        font-weight: bold;
        font-size: 16px;
        @media screen and (max-width: 768px) {
          font-size: 0.9rem;
        }
        .el-tag{
          height: 22px;
          line-height: 22px;
          margin-left: 10px;
          font-size: 12px;
          @media screen and (max-width: 768px) {
            font-size: 0.6rem;
            height: 1rem;
            line-height: 0.9rem;
          }
        }

        .el-tag--dark {
          background-color: #8CCBFF;
          border-color: #8CCBFF;
          @media screen and (max-width: 768px) {
            font-size: 0.7rem;
          }
        }
        .el-tag--dark.el-tag--danger {
           background-color: #FF8C8C;
           border-color: #FF8C8C;
           color: #fff;
          @media screen and (max-width: 768px) {
            font-size: 0.7rem;
          }
         }

      }
      .pro-desc{
        font-size: 14px;
        color: #2E3742;
        margin-bottom: 10px;
        @media screen and (max-width: 768px) {
          font-size: 0.7rem;
          margin-bottom: 5PX;
        }
      }
      .pro-yp{
        color: #2E3742;
        font-size: 13px;
        font-weight: normal;
        @media screen and (max-width: 768px) {
          font-size: 0.7rem;
          line-height: 1.0rem;
        }
      }
      .line{
        background-color: #2E3742;
        @media screen and (max-width: 768px) {
          height: 0.05rem;
          background-color: #2E3742;
          margin: 10px 0;
        }
      }
      .point{
        width: 6px;
        height: 6px;
        border-radius: 3px;
        background-color: #2E3742 ;
        float: left;
        margin-top: 8px;
        margin-right: 10px;
        @media screen and (max-width: 768px) {
          width: 4PX;
          height: 4PX;
          margin-top: 5PX;
          margin-right: 5PX;
          border-radius: 4PX;
        }
      }
    }
    .bg-mask{
      background-color: rgba(0,0,0,0);
      height: 280px;
      width: 100%;
      position:relative;
      margin-top: -274px;
      color: #fff;
      display:flex;justify-content: center;
      align-items: center;
      flex-direction: column;
      font-size: 18px;
      font-weight: bold;
      @media screen and (max-width: 768px) {
        height: 100PX;
        margin-top: -100PX;
      }
      .fa_btn{
        background-color: #0052D9;
        border-color: #0052d9;
        margin-top: 100px;
        padding-top: 10px;
        padding-bottom: 10px;
        display: none;
      }
    }
    &:hover {
      .image{
        transform: scale(1.1);
        transition: transform 0.3s linear;
      }
      //.pro-text{
      //  position: relative;
      //  height: 100px;
      //  transition: transform 0.3s ease;
      //  margin-top: -10px;
      //  background-color: #fff;
      //}
      .bg-mask{
        background-color: rgba(0, 0, 0, 0.6);
        //background-color: rgba(247, 248, 250, 0.6);
        .fa_btn{
          display: block;
        }
      }
    }
  }

}
.case-item{
  margin-bottom: 12px !important;
  .ys-img{
    img{
      height: 240px;
      @media screen and (max-width: 768px) {
        height: 180PX;
      }
    }
  }

  .el-card{
    border-radius: 8px;
    @media screen and (max-width: 768px) {
      border-radius: 5PX;
      padding-bottom: 10PX;
      margin-bottom: 5PX;
    }
  }
  .bg-mask{
    background-color: rgba(0,0,0,0);
    height: 284px;
    width: 100%;
    position:relative;
    margin-top: -274px;
    color: #fff;
    display:flex;justify-content: center;
    align-items: center;
    flex-direction: column;
    font-size: 18px;
    font-weight: bold;
    @media screen and (max-width: 768px) {
      height: 100PX;
      margin-top: -100PX;
    }
    .fa_btn{
      background-color: #0052D9;
      border-color: #0052d9;
      margin-top: 40px;
      padding-top: 10px;
      padding-bottom: 10px;
      display: none;
    }
  }
  &:hover {
    .ys-img {
      img {
        transform: scale(1.1);
        transition: transform 0.3s linear;
      }
    }
    .bg-mask{
      background-color: rgba(0, 0, 0, 0.6);
      //background-color: rgba(247, 248, 250, 0.6);
      .fa_btn{
        display: block;
      }
    }
  }
}
.arrow-text{
  height: 50px;
  float: left;
  margin-right: 5px;
}
.arrow-text2{
  margin-top: 24px;
  margin-right: 5px;
  height: 50px;
  float: left;

}
.arrow2{
  width: 20px;
  float: left;
  margin-top: 27px;
}
.arrow{
  width: 20px;
  float: left;
  margin-top: 3px;
}
.sy-footer{
  background-color: #000000;
  color: #fff;
  padding: 40px 0;
  font-size: 14px;
  line-height: 24px;
  @media screen and (max-width: 768px) {
    padding: 10PX 0 24px 0;
    font-size: 0.8rem;
    line-height: 1rem;
  }
  .sy-desc{
    margin-top: 10px;
    @media screen and (max-width: 768px) {
      font-size: 0.6rem;
      line-height: 1.2rem;
    }
    .sub-name{
      font-size: 12px;
      @media screen and (max-width: 768px) {
        font-size: 0.8rem;
        line-height: 1.2rem;
      }
    }
  }
  .sy-desc2{
    font-size: 14px;
    margin-top: 11px;
    @media screen and (max-width: 768px) {
      font-size: 0.8rem;
      line-height: 1.2rem;
    }
    .sub-name{
      font-size: 12px;
      color: rgba(255, 255, 255, 0.8);
      @media screen and (max-width: 768px) {
        font-size: 0.6rem;
        line-height: 1.2rem;
      }
    }
  }
}
.copyright{
  background-color: #383838;
  padding: 8px 0;
  font-size: 12px;
  text-align: center;
  color: #fff;
}
</style>